module.exports = __webpack_public_path__ + "img/Logo-30.94a16b29.svg";